"use client";

import { c as _c } from "react/compiler-runtime";
import type { FilterContentProps } from "./FilterContent";
import FilterContent from "./FilterContent";
interface FilterPanelProps extends FilterContentProps {
  className?: string;
}
export default function FilterPanel(t0) {
  const $ = _c(8);
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = t1;
  } else {
    rest = $[1];
    t1 = $[2];
  }
  const className = t1 === undefined ? "" : t1;
  const t2 = `hidden md:flex p-6 flex-col gap-5 rounded-xl backdrop-blur-4xl bg-background/40 w-[285px] sticky top-10 self-start ${className}`;
  let t3;
  if ($[3] !== rest) {
    t3 = <FilterContent {...rest} />;
    $[3] = rest;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <aside className={t2}>{t3}</aside>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}